import { addProp } from "@pnp/odata";
import { _User } from "../users/types.js";
import { Photo } from "./types.js";
addProp(_User, "photo", Photo);
//# sourceMappingURL=users.js.map